import { render } from "./UserList.vue?vue&type=template&id=559e71c8"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"
script.render = render

export default script